import {Upload, UploadState} from 'platform/components';
import {Box} from 'platform/foundation';
import {RcFile} from 'rc-upload/lib/interface';

import {CSSProperties, useState} from 'react';

import i18n from '@dms/i18n';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

interface VehicleAlbumUploadVideoTileProps extends RequiredTestIdProps {
  ratio?: CSSProperties['aspectRatio'];
  isDisabled?: boolean;
  onStartVideoUpload: (file: RcFile) => Promise<void>;
}

// Dedicated "Add video" upload tile rendered next to the existing photo upload tile. The actual
// chunked upload is performed in `onStartVideoUpload` (the platform Upload `customRequest` is a
// no-op); this is the album counterpart of the inspection-flow `UploadVideo`, without the
// audit-only `useConditionContext` coupling.
export function VehicleAlbumUploadVideoTile(props: VehicleAlbumUploadVideoTileProps) {
  const [uploadState, setUploadState] = useState<UploadState>(UploadState.Idle);

  const handleStartUpload = async (file: RcFile) => {
    setUploadState(UploadState.Uploading);
    await props.onStartVideoUpload(file);
    setUploadState(UploadState.Success);
  };

  return (
    <Box width="100%" height="100%" ratio={props.ratio} position="relative" overflow="hidden">
      <Upload
        size="default"
        accept="video/*"
        type="card"
        uploadIcon="image/video_call"
        uploadText={i18n.t('entity.video.labels.add')}
        errorIcon="navigation/cancel"
        customRequest={({onSuccess}) => {
          onSuccess?.('', new XMLHttpRequest());
        }}
        onStart={handleStartUpload}
        uploadState={uploadState}
        isMultiple
        isDisabled={props.isDisabled}
        data-testid={suffixTestId('uploadVideo', props)}
      />
    </Box>
  );
}
